"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1068. Curs Online de Biodata - Gravació
    {
        id: 1068,
        category: [
            product_types_1.Category.Online,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.21,
        sku: "iopos.course.online.curs-online-biodata-13-02-2026",
        title: "Curs Online de Biodata - Gravació",
        name: "Curs Online de Biodata - Gravació",
        description: "Prepara el Biodata amb criteri real de tribunal, des d'on vulguis i sense improvisar.",
        enabled: false,
        stock: true,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 99.99,
        // shipment: 0.0,
        images: ["/1068/image3"],
        banner: ["/1068/image3"],
        link: "/tienda/cursos/curs-online-biodata-gravacio/",
        created_at: "2026-02-14 00:00:01",
        start_at: "2026-02-14 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        // sendPersonalityTestLink: true,
        evolmind: {
            course_id: 289,
            group_id: [2914],
        },
    },
    // 1069. Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2026 - Grup 1
    {
        id: 1069,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.f2f.curs-preparacio-adequacio-psicoprofessional-mossos-2026-g18",
        title: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 18] (7/02/26 9-14 h) [Segon Grup]",
        name: "Curs Presencial Preparació Tercera Prova Mossos 2026 [Grup 18] (7/02/26 9-14 h) [Segon Grup]",
        short: "18. Curs Preparació Tercera Prova Mossos 2026 [Grup 18] [7/02/26 9-14 h] [Segon Grup]",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/953/image1"],
        banner: ["/953/image1"],
        link: "/tienda/cursos/curs-presencial-preparacio-tercera-prova-mossos-2026/",
        created_at: "2025-12-01 00:00:01",
        start_at: "2025-12-01 00:00:01",
        more_info: false,
        items: 1,
        parent: 953,
        evolmind: {
            course_id: 289,
            group_id: [2941],
        },
        limit: 30,
        sendPersonalityTestLink: true,
    },
    // 1070. Curso de Conducción Segura y Prevención de Accidentes
    {
        id: 1070,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-2026",
        title: "Curs de Conducció Segura i Prevenció d'Accidents (Bombers)",
        name: "Curs de Conducció Segura i Prevenció d'Accidents (Bombers)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "Formació especialitzada orientada a reforçar la conducció segura i la prevenció d’accidents laborals viaris en el servei operatiu de Bombers, amb criteri tècnic, responsabilitat i cultura preventiva.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1070/image1"],
        banner: ["/1070/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1071, 1072],
        multiple_languages: false,
    },
    // 1071. Curso de Conducción Segura y Prevención de Accidentes - ES
    {
        id: 1071,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-2026-es",
        title: "Curso de Conducción Segura y Prevención de Accidentes",
        name: "Curso de Conducción Segura y Prevención de Accidentes",
        short: "1.) Conducción Segura y Prevención de Accidentes",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1070/image1"],
        banner: ["/1070/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1070,
        evolmind: { course_id: 1075, group_id: [2917] },
    },
    // 1072. Curso de Conducción Segura y Prevención de Accidentes - CA
    {
        id: 1072,
        tax: 0.21,
        sku: "iopos.course.online.curso-conduccion-segura-prevencion-accidentes-2026-ca",
        title: "Curs de Conducció Segura i Prevenció d'Accidents",
        name: "Curs de Conducció Segura i Prevenció d'Accidents",
        short: "1.) Conducció Segura i Prevenció d'Accidents",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1070/image1"],
        banner: ["/1070/image1"],
        link: "/tienda/cursos/formacion-policial/curso-conduccion-segura-prevencion-accidentes-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1070,
        evolmind: { course_id: 1078, group_id: [2920] },
    },
    // 1073. Curso Primera Intervención Frente al Fuego (Bomberos)
    {
        id: 1073,
        tax: 0.21,
        sku: "iopos.course.online.curso-primera-intervencion-frente-al-fuego-bomberos-2026",
        title: "Curs Primera Intervenció Enfront al Foc (Bombers)",
        name: "Curs Primera Intervenció Enfront al Foc (Bombers)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "Formació tècnica i operativa orientada a capacitar els membres del cos de Bombers en la primera intervenció davant del foc.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1073/image1"],
        banner: ["/1073/image1"],
        link: "/tienda/cursos/formacion-policial/curso-primera-intervencion-frente-al-fuego-bomberos-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1074, 1075],
        multiple_languages: false,
    },
    // 1074. Curso Primera Intervención Frente al Fuego (Bomberos) - ES
    {
        id: 1074,
        tax: 0.21,
        sku: "iopos.course.online.curso-primera-intervencion-frente-al-fuego-bomberos-2026-es",
        title: "Curso Primera Intervención Frente al Fuego (Bomberos)",
        name: "Curso Primera Intervención Frente al Fuego (Bomberos)",
        short: "1.) Primera Intervención Frente al Fuego (Bomberos)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1073/image1"],
        banner: ["/1073/image1"],
        link: "/tienda/cursos/formacion-policial/curso-primera-intervencion-frente-al-fuego-bomberos-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1073,
        evolmind: { course_id: 1084, group_id: [2926] },
    },
    // 1075. Curso Primera Intervención Frente al Fuego (Bomberos) - CA
    {
        id: 1075,
        tax: 0.21,
        sku: "iopos.course.online.curso-primera-intervencion-frente-al-fuego-bomberos-2026-ca",
        title: "Curs Primera Intervenció Enfront al Foc (Bombers)",
        name: "Curs Primera Intervenció Enfront al Foc (Bombers)",
        short: "1.) Primera Intervenció Enfront al Foc (Bombers)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1073/image1"],
        banner: ["/1073/image1"],
        link: "/tienda/cursos/formacion-policial/curso-primera-intervencion-frente-al-fuego-bomberos-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1073,
        evolmind: { course_id: 1081, group_id: [2923] },
    },
    // 1076. Curso Trabajos en Altura (Bomberos)
    {
        id: 1076,
        tax: 0.21,
        sku: "iopos.course.online.curso-trabajos-en-altura-bomberos-2026",
        title: "Curs Treballs en Alçada (Bombers)",
        name: "Curs Treballs en Alçada (Bombers)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "Formació tècnica especialitzada orientada a garantir la seguretat, la prevenció de riscos i la correcta aplicació normativa en treballs en altura dins l’àmbit operatiu de Bombers.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1076/image2"],
        banner: ["/1076/image2"],
        link: "/tienda/cursos/formacion-policial/curso-trabajos-en-altura-bomberos-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1077, 1078],
        multiple_languages: false,
    },
    // 1077. Curso Trabajos en Altura (Bomberos) - ES
    {
        id: 1077,
        tax: 0.21,
        sku: "iopos.course.online.curso-trabajos-en-altura-bomberos-2026-es",
        title: "Curso Trabajos en Altura (Bomberos)",
        name: "Curso Trabajos en Altura (Bomberos)",
        short: "1.) Trabajos en Altura (Bomberos)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1076/image2"],
        banner: ["/1076/image2"],
        link: "/tienda/cursos/formacion-policial/curso-trabajos-en-altura-bomberos-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1076,
        evolmind: { course_id: 1087, group_id: [2929] },
    },
    // 1078. Curso Trabajos en Altura (Bomberos) - CA
    {
        id: 1078,
        tax: 0.21,
        sku: "iopos.course.online.curso-trabajos-en-altura-bomberos-2026-ca",
        title: "Curs Treballs en Alçada (Bombers)",
        name: "Curs Treballs en Alçada (Bombers)",
        short: "1.) Treballs en Alçada (Bombers)",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.BOMBEROS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1076/image2"],
        banner: ["/1076/image2"],
        link: "/tienda/cursos/formacion-policial/curso-trabajos-en-altura-bomberos-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1076,
        evolmind: { course_id: 1090, group_id: [2932] },
    },
    // 1079. Curso de Introducción a la Protección Civil
    {
        id: 1079,
        tax: 0.0,
        sku: "iopos.course.online.curso-introduccion-proteccion-civil-2026",
        title: "Curs Introducció a la Protecció Civil",
        name: "Curs Introducció a la Protecció Civil",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_CIVIL_Y_EMERGENCIAS,
        ],
        description: "Formació especialitzada orientada a proporcionar una visió estructurada del sistema de protecció civil a Catalunya i el paper dels cossos policials en la gestió d’emergències col·lectives.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1079/image1"],
        banner: ["/1079/image1"],
        link: "/tienda/cursos/formacion-policial/curso-introduccion-proteccion-civil-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1080, 1081],
        multiple_languages: false,
    },
    // 1080. Curso de Introducción a la Protección Civil - ES
    {
        id: 1080,
        tax: 0.0,
        sku: "iopos.course.online.curso-introduccion-proteccion-civil-2026-es",
        title: "Curso de Introducción a la Protección Civil",
        name: "Curso de Introducción a la Protección Civil",
        short: "1.) Introducción a la Protección Civil",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_CIVIL_Y_EMERGENCIAS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1079/image1"],
        banner: ["/1079/image1"],
        link: "/tienda/cursos/formacion-policial/curso-introduccion-proteccion-civil-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1079,
        evolmind: { course_id: 1096, group_id: [2938] },
    },
    // 1081. Curso de Introducción a la Protección Civil - CA
    {
        id: 1081,
        tax: 0.0,
        sku: "iopos.course.online.curso-introduccion-proteccion-civil-2026-ca",
        title: "Curs Introducció a la Protecció Civil",
        name: "Curs Introducció a la Protecció Civil",
        short: "1.) Introducció a la Protecció Civil",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_CIVIL_Y_EMERGENCIAS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1079/image1"],
        banner: ["/1079/image1"],
        link: "/tienda/cursos/formacion-policial/curso-introduccion-proteccion-civil-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1079,
        evolmind: { course_id: 1093, group_id: [2935] },
    },
    // 1082. Test PAPI 3 - Avaluació del Perfil Psicoprofessional
    {
        id: 1082,
        category: [
            product_types_1.Category.Online,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.21,
        sku: "iopos.course.online.test-papi3-avaluacio-perfil-psicoprofessional-2026",
        title: "Test PAPI 3 - Avaluació del Perfil Psicoprofessional",
        name: "Test PAPI 3 - Avaluació del Perfil Psicoprofessional",
        description: "Prepara el Biodata amb criteri professional i evita errors que poden deixar-te fora del procés.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 79.99,
        shipment: 0.0,
        images: ["/1082/image1"],
        banner: ["/1082/image1"],
        link: "/tienda/cursos/test-papi3-avaluacio-perfil-psicoprofessional-2026/",
        created_at: "2026-01-21 00:00:01",
        start_at: "2026-01-21 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        sendPersonalityTestLink: true,
        notify_emails: ["testpsicos@iopos.academy"],
    },
    // 1083. Seminari Online de Dret Penal i Processal 2026
    {
        id: 1083,
        category: [product_types_1.Category.Online, product_types_1.Category.ISPC],
        tax: 0.21,
        sku: "iopos.course.online.seminari-online-dret-penal-processal-2026",
        title: "Seminari Online de Dret Penal i Processal 2026",
        name: "Seminari Online de Dret Penal i Processal 2026",
        description: "Domina el dret penal amb una formació avançada, pràctica i totalment alineada amb els barems de l’ISPC 2026.",
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        // low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 69.99,
        shipment: 0.0,
        images: ["/1083/image1"],
        banner: ["/1083/image1"],
        link: "/tienda/cursos/seminari-online-dret-penal-processal-2026/",
        created_at: "2026-01-21 00:00:01",
        start_at: "2026-01-21 00:00:01",
        more_info: true,
        release: false,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: {
            course_id: 489,
            group_id: [2980],
        },
    },
    // 1084. Curso Comunicación, trabajo en equipo y control del estrés
    {
        id: 1084,
        tax: 0.0,
        sku: "iopos.course.online.curso-comunicacion-trabajo-equipo-control-estres-2026",
        title: "Curs Comunicació, treball en equip i control de l'estrès",
        name: "Curs Comunicació, treball en equip i control de l'estrès",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a reforçar les habilitats comunicatives, el treball en equip i la gestió de l’estrès operatiu en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1084/image1"],
        banner: ["/1084/image1"],
        link: "/tienda/cursos/formacion-policial/curso-comunicacion-trabajo-equipo-control-estres-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1085, 1086],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070863",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Comunicació, treball en equip i control de l'estrès",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **millorar** les habilitats de **comunicació**, **treball en equip** i **gestió de l’estrès** en l’àmbit policial.",
            landscape: "/1084/hero_h",
            portrait: "/1084/hero_v",
        },
    },
    // 1085. Curso Comunicación, trabajo en equipo y control del estrés - ES
    {
        id: 1085,
        tax: 0.0,
        sku: "iopos.course.online.curso-comunicacion-trabajo-equipo-control-estres-2026-es",
        title: "Curso Comunicación, trabajo en equipo y control del estrés",
        name: "Curso Comunicación, trabajo en equipo y control del estrés",
        short: "1.) Comunicación, trabajo en equipo y control del estrés",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1084/image1"],
        banner: ["/1084/image1"],
        link: "/tienda/cursos/formacion-policial/curso-comunicacion-trabajo-equipo-control-estres-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1084,
        evolmind: { course_id: 1099, group_id: [2944] },
    },
    // 1086. Curso Comunicación, trabajo en equipo y control del estrés - CA
    {
        id: 1086,
        tax: 0.0,
        sku: "iopos.course.online.curso-comunicacion-trabajo-equipo-control-estres-2026-ca",
        title: "Curs Comunicació, treball en equip i control de l'estrès",
        name: "Curs Comunicació, treball en equip i control de l'estrès",
        short: "1.) Comunicació, treball en equip i control de l'estrès",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1084/image1"],
        banner: ["/1084/image1"],
        link: "/tienda/cursos/formacion-policial/curso-comunicacion-trabajo-equipo-control-estres-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1084,
        evolmind: { course_id: 1102, group_id: [2947] },
    },
    // 1087. Curso Ley de Bienestar Animal y los Delitos contra los Animales
    {
        id: 1087,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-bienestar-animal-delitos-contra-animales-2026",
        title: "Curs Llei de Benestar Animal i els Delictes contra els Animals",
        name: "Curs Llei de Benestar Animal i els Delictes contra els Animals",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "Formació jurídica especialitzada orientada a aplicar amb criteri tècnic la Llei 7/2023 de benestar animal i els delictes de maltractament i abandonament regulats al Codi Penal.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1087/image1"],
        banner: ["/1087/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-bienestar-animal-delitos-contra-animales-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1088, 1089],
        multiple_languages: false,
    },
    // 1088. Curso Ley de Bienestar Animal y los Delitos contra los Animales - ES
    {
        id: 1088,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-bienestar-animal-delitos-contra-animales-2026-es",
        title: "Curso Ley de Bienestar Animal y los Delitos contra los Animales",
        name: "Curso Ley de Bienestar Animal y los Delitos contra los Animales",
        short: "1.) Ley de Bienestar Animal y los Delitos contra los Animales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1087/image1"],
        banner: ["/1087/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-bienestar-animal-delitos-contra-animales-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1087,
        evolmind: { course_id: 1105, group_id: [2950] },
    },
    // 1089. Curso Ley de Bienestar Animal y los Delitos contra los Animales - CA
    {
        id: 1089,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-bienestar-animal-delitos-contra-animales-2026-ca",
        title: "Curs Llei de Benestar Animal i els Delictes contra els Animals",
        name: "Curs Llei de Benestar Animal i els Delictes contra els Animals",
        short: "1.) Llei de Benestar Animal i els Delictes contra els Animals",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1087/image1"],
        banner: ["/1087/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-bienestar-animal-delitos-contra-animales-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1087,
        evolmind: { course_id: 1108, group_id: [2953] },
    },
    // 1090. Curso Ley Orgánica 4 - 2015
    {
        id: 1090,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-organica-4-2015-2026",
        title: "Curs Llei Orgànica 4 / 2015",
        name: "Curs Llei Orgànica 4 / 2015",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació jurídica especialitzada orientada a dominar l'aplicació operativa de la Llei Orgànica 4/2015 en l’actuació policial diària amb plena seguretat jurídica.",
        enabled: false,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1090/image1"],
        banner: ["/1090/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-organica-4-2015-2026/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1091, 1092],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de la Llei Orgànica 4 / 2015",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **jurídica especialitzada** orientada a **dominar** l'**aplicació operativa** de la **Llei Orgànica 4/2015** en l’**actuació policial diària** amb **plena seguretat jurídica**.",
            landscape: "/1090/hero_h",
            portrait: "/1090/hero_v",
        },
    },
    // 1091. Curso Ley Orgánica 4 - 2015 - ES
    {
        id: 1091,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-organica-4-2015-2026-es",
        title: "Curso Ley Orgánica 4 / 2015",
        name: "Curso Ley Orgánica 4 / 2015",
        short: "2.) Ley Orgánica 4 / 2015",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1091/image1"],
        banner: ["/1091/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-organica-4-2015-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1090,
        evolmind: { course_id: 1111, group_id: [2956] },
    },
    // 1092. Curso Ley Orgánica 4 - 2015 - CA
    {
        id: 1092,
        tax: 0.0,
        sku: "iopos.course.online.curso-ley-organica-4-2015-2026-ca",
        title: "Curs Llei Orgànica 4 / 2015",
        name: "Curs Llei Orgànica 4 / 2015",
        short: "1.) Llei Orgànica 4 / 2015",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1090/image1"],
        banner: ["/1090/image1"],
        link: "/tienda/cursos/formacion-policial/curso-ley-organica-4-2015-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1090,
        evolmind: { course_id: 1114, group_id: [2959] },
    },
    // 1093. Curso Mediación Policial
    {
        id: 1093,
        tax: 0.0,
        sku: "iopos.course.online.curso-mediacion-policial-2026",
        title: "Curs Mediació Policial",
        name: "Curs Mediació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a dotar els professionals policials d’eines tècniques i comunicatives per intervenir en conflictes mitjançant la mediació, amb criteri jurídic i enfocament comunitari.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1093/image1"],
        banner: ["/1093/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mediacion-policial/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1094, 1095],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070881",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Mediació Policial",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a dotar els professionals policials d’eines tècniques i comunicatives per intervenir en conflictes mitjançant la mediació, amb criteri jurídic i enfocament comunitari.",
            landscape: "/1093/hero_h",
            portrait: "/1093/hero_v",
        },
    },
    // 1094. Curso Mediación Policial - ES
    {
        id: 1094,
        tax: 0.0,
        sku: "iopos.course.online.curso-mediacion-policial-2026-es",
        title: "Curso Mediación Policial",
        name: "Curso Mediación Policial",
        short: "1.) Mediación Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1093/image1"],
        banner: ["/1093/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mediacion-policial-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1093,
        evolmind: { course_id: 1117, group_id: [2962] },
    },
    // 1095. Curso Mediación Policial - CA
    {
        id: 1095,
        tax: 0.0,
        sku: "iopos.course.online.curso-mediacion-policial-2026-ca",
        title: "Curs Mediació Policial",
        name: "Curs Mediació Policial",
        short: "1.) Mediació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1093/image1"],
        banner: ["/1093/image1"],
        link: "/tienda/cursos/formacion-policial/curso-mediacion-policial-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1093,
        evolmind: { course_id: 1120, group_id: [2965] },
    },
    // 1096. Curso Modelo Policial de Proximidad
    {
        id: 1096,
        tax: 0.0,
        sku: "iopos.course.online.curso-modelo-policial-proximidad-2026",
        title: "Curs Model Policial de Proximitat",
        name: "Curs Model Policial de Proximitat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "Formació especialitzada orientada a consolidar el model policial de proximitat com a estratègia preventiva, comunitària i territorial al servei de la convivència i la cohesió social.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1096/image1"],
        banner: ["/1096/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelo-policial-proximidad/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1097, 1098],
        multiple_languages: false,
    },
    // 1097. Curso Modelo Policial de Proximidad - ES
    {
        id: 1097,
        tax: 0.0,
        sku: "iopos.course.online.curso-modelo-policial-proximidad-2026-es",
        title: "Curso Modelo Policial de Proximidad",
        name: "Curso Modelo Policial de Proximidad",
        short: "1.) Modelo Policial de Proximidad",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1097/image1"],
        banner: ["/1097/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelo-policial-proximidad-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1096,
        evolmind: { course_id: 1126, group_id: [2971] },
    },
    // 1098. Curso Modelo Policial de Proximidad - CA
    {
        id: 1098,
        tax: 0.0,
        sku: "iopos.course.online.curso-modelo-policial-proximidad-2026-ca",
        title: "Curs Model Policial de Proximitat",
        name: "Curs Model Policial de Proximitat",
        short: "1.) Model Policial de Proximitat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1096/image1"],
        banner: ["/1096/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelo-policial-proximidad-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1096,
        evolmind: { course_id: 1123, group_id: [2968] },
    },
    // 1099. Curso de Apoyo Psicológico en Situaciones de Emergencias
    {
        id: 1099,
        tax: 0.0,
        sku: "iopos.course.online.curso-apoyo-psico-situaciones-emergencias-2026",
        title: "Curs de Suport Psicològic en Situacions d'Emergències",
        name: "Curs de Suport Psicològic en Situacions d'Emergències",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a dotar els professionals de seguretat d’eines tècniques i emocionals per intervenir adequadament en situacions d’emergència amb víctimes i col·lectius vulnerables.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1099/image1"],
        banner: ["/1099/image1"],
        link: "/tienda/cursos/formacion-policial/curso-apoyo-psicologico-situaciones-emergencias/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1100, 1101],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070889",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Suport Psicològic en Situacions d'Emergències",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a dotar els professionals de seguretat d’eines tècniques i emocionals per intervenir adequadament en situacions d’emergència amb víctimes i col·lectius vulnerables.",
            landscape: "/1099/hero_h",
            portrait: "/1099/hero_v",
        },
    },
    // 1100. Curso de Apoyo Psicológico en Situaciones de Emergencias - ES
    {
        id: 1100,
        tax: 0.0,
        sku: "iopos.course.online.curso-apoyo-psicologico-situaciones-emergencias-2026-es",
        title: "Curso de Apoyo Psicológico en Situaciones de Emergencias",
        name: "Curso de Apoyo Psicológico en Situaciones de Emergencias",
        short: "1.) Apoyo Psicológico en Situaciones de Emergencias",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1100/image1"],
        banner: ["/1100/image1"],
        link: "/tienda/cursos/formacion-policial/curso-apoyo-psicologico-situaciones-emergencias-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1099,
        evolmind: { course_id: 1129, group_id: [2974] },
    },
    // 1101. Curso de Apoyo Psicológico en Situaciones de Emergencias - CA
    {
        id: 1101,
        tax: 0.0,
        sku: "iopos.course.online.curso-apoyo-psicologico-situaciones-emergencias-2026-ca",
        title: "Curs de Suport Psicològic en Situacions d'Emergències",
        name: "Curs de Suport Psicològic en Situacions d'Emergències",
        short: "1.) Suport Psicològic en Situacions d'Emergències",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1099/image1"],
        banner: ["/1099/image1"],
        link: "/tienda/cursos/formacion-policial/curso-apoyo-psicologico-situaciones-emergencias-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1099,
        evolmind: { course_id: 1132, group_id: [2977] },
    },
    // 1102. Curso Derecho Constitucional y Estatutario
    {
        id: 1102,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-constitucional-estatutario-2026",
        title: "Curs de Dret Constitucional i Estatutari",
        name: "Curs de Dret Constitucional i Estatutari",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació jurídica especialitzada orientada a consolidar els fonaments del dret constitucional i estatutari com a marc essencial de l’actuació policial en un Estat de dret.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1102/image1"],
        banner: ["/1102/image1"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-constitucional-estatutario/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1103, 1104],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250071091",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 36,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Dret Constitucional i Estatutari",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a consolidar els fonaments del dret constitucional i estatutari com a marc essencial de l’actuació policial en un Estat de dret.",
            landscape: "/1102/hero_h",
            portrait: "/1102/hero_v",
        },
    },
    // 1103. Curso Curso Derecho Constitucional y Estatutario - ES
    {
        id: 1103,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-constitucional-estatutario-2026-es",
        title: "Curso de Derecho Constitucional y Estatutario",
        name: "Curso de Derecho Constitucional y Estatutario",
        short: "1.) Derecho Constitucional y Estatutario",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1102/image1"],
        banner: ["/1102/image1"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-constitucional-estatutario-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1102,
        evolmind: { course_id: 1138, group_id: [2986] },
    },
    // 1104. Curso Derecho Constitucional y Estatutario - CA
    {
        id: 1104,
        tax: 0.0,
        sku: "iopos.course.online.curso-derecho-constitucional-estatutario-2026-ca",
        title: "Curs de Dret Constitucional i Estatutari",
        name: "Curs de Dret Constitucional i Estatutari",
        short: "1.) Dret Constitucional i Estatutari",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/1102/image1"],
        banner: ["/1102/image1"],
        link: "/tienda/cursos/formacion-policial/curso-derecho-constitucional-estatutario-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1102,
        evolmind: { course_id: 1135, group_id: [2983] },
    },
    // 1105. Curso Estructura Social de Cataluña
    {
        id: 1105,
        tax: 0.21,
        sku: "iopos.course.online.curso-estructura-social-cataluna-2026",
        title: "Curs d'Estructura Social de Catalunya",
        name: "Curs d'Estructura Social de Catalunya",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació especialitzada orientada a comprendre l’estructura social catalana i el paper de la policia com a servei públic dins l’Estat del benestar.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1105/image1"],
        banner: ["/1105/image1"],
        link: "/tienda/cursos/formacion-policial/curso-estructura-social-cataluna/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1106, 1107],
        multiple_languages: false,
    },
    // 1106. Curso Estructura Social de Cataluña - ES
    {
        id: 1106,
        tax: 0.21,
        sku: "iopos.course.online.curso-estructura-social-cataluna-2026-es",
        title: "Curso de Estructura Social de Cataluña",
        name: "Curso de Estructura Social de Cataluña",
        short: "1.) Estructura Social de Cataluña",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1105/image1"],
        banner: ["/1105/image1"],
        link: "/tienda/cursos/formacion-policial/curso-estructura-social-cataluna-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1105,
        evolmind: { course_id: 1144, group_id: [2992] },
    },
    // 1107. Curso Estructura Social de Cataluña - CA
    {
        id: 1107,
        tax: 0.21,
        sku: "iopos.course.online.curso-estructura-social-cataluna-2026-ca",
        title: "Curs d'Estructura Social de Catalunya",
        name: "Curs d'Estructura Social de Catalunya",
        short: "1.) Estructura Social de Catalunya",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1105/image1"],
        banner: ["/1105/image1"],
        link: "/tienda/cursos/formacion-policial/curso-estructura-social-cataluna-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1105,
        evolmind: { course_id: 1141, group_id: [2989] },
    },
    // 1108. Curso Ética y Deontología Policial
    {
        id: 1108,
        tax: 0.21,
        sku: "iopos.course.online.curso-etica-deontologia-policial-2026",
        title: "Curs d'Ètica i Deontologia Policial",
        name: "Curs d'Ètica i Deontologia Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació jurídica i professional orientada a consolidar els fonaments ètics i deontològics de la funció policial, garantint una actuació íntegra, imparcial i respectuosa amb els drets fonamentals.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1108/image1"],
        banner: ["/1108/image1"],
        link: "/tienda/cursos/formacion-policial/curso-etica-deontologia-policial/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1109, 1110],
        multiple_languages: false,
    },
    // 1109. Curso Ética y Deontología Policial - ES
    {
        id: 1109,
        tax: 0.21,
        sku: "iopos.course.online.curso-etica-deontologia-policial-2026-es",
        title: "Curso de Ética y Deontología Policial",
        name: "Curso de Ética y Deontología Policial",
        short: "1.) Ética y Deontología Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1108/image1"],
        banner: ["/1108/image1"],
        link: "/tienda/cursos/formacion-policial/curso-etica-deontologia-policial-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1108,
        evolmind: { course_id: 1150, group_id: [2998] },
    },
    // 1110. Curso Ética y Deontología Policial - CA
    {
        id: 1110,
        tax: 0.21,
        sku: "iopos.course.online.curso-etica-deontologia-policial-2026-ca",
        title: "Curs d'Ètica i Deontologia Policial",
        name: "Curs d'Ètica i Deontologia Policial",
        short: "1.) Ètica i Deontologia Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1110/image1"],
        banner: ["/1110/image1"],
        link: "/tienda/cursos/formacion-policial/curso-etica-deontologia-policial-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1105,
        evolmind: { course_id: 1147, group_id: [2995] },
    },
    // 1111. Curso La Planificación Policial
    {
        id: 1111,
        tax: 0.21,
        sku: "iopos.course.online.curso-planificacion-policial-2026",
        title: "Curs de La Planificació Policial",
        name: "Curs de La Planificació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació especialitzada orientada a dotar els professionals policials d’eines estratègiques per planificar, gestionar per processos i dissenyar dispositius operatius amb criteri tècnic i orientació a resultats.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1111/image1"],
        banner: ["/1111/image1"],
        link: "/tienda/cursos/formacion-policial/curso-planificacion-policial/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1112, 1113],
        multiple_languages: false,
    },
    // 1112. Curso La Planificación Policial - ES
    {
        id: 1112,
        tax: 0.21,
        sku: "iopos.course.online.curso-planificacion-policial-2026-es",
        title: "Curso de La Planificación Policial",
        name: "Curso de La Planificación Policial",
        short: "1.) La Planificación Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1111/image1"],
        banner: ["/1111/image1"],
        link: "/tienda/cursos/formacion-policial/curso-planificacion-policial-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1111,
        evolmind: { course_id: 1153, group_id: [3001] },
    },
    // 1113. Curso La Planificación Policial - CA
    {
        id: 1113,
        tax: 0.21,
        sku: "iopos.course.online.curso-planificacion-policial-2026-ca",
        title: "Curs de La Planificació Policial",
        name: "Curs de La Planificació Policial",
        short: "1.) La Planificació Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1111/image1"],
        banner: ["/1111/image1"],
        link: "/tienda/cursos/formacion-policial/curso-planificacion-policial-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1105,
        evolmind: { course_id: 1156, group_id: [3004] },
    },
    // 1114. Curso Manejo y Mantenimiento de los Vehículos Policiales
    {
        id: 1114,
        tax: 0.21,
        sku: "iopos.course.online.curso-manejo-mantenimiento-vehiculos-policiales-2026",
        title: "Curs de Maneig i Manteniment dels Vehicles Policials",
        name: "Curs de Maneig i Manteniment dels Vehicles Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació tècnica i operativa orientada a garantir un ús segur, eficient i professional dels vehicles policials, amb domini normatiu, mecànic i comunicatiu.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1114/image1"],
        banner: ["/1114/image1"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-mantenimiento-vehiculos-policiales/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1115, 1116],
        multiple_languages: false,
    },
    // 1115. Curso Manejo y Mantenimiento de los Vehículos Policiales - ES
    {
        id: 1115,
        tax: 0.21,
        sku: "iopos.course.online.curso-manejo-mantenimiento-vehiculos-policiales-2026-es",
        title: "Curso de Manejo y Mantenimiento de los Vehículos Policiales",
        name: "Curso de Manejo y Mantenimiento de los Vehículos Policiales",
        short: "1.) Manejo y Mantenimiento de los Vehículos Policiales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1114/image1"],
        banner: ["/1114/image1"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-mantenimiento-vehiculos-policiales-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1114,
        evolmind: { course_id: 1162, group_id: [3010] },
    },
    // 1116. Curso Manejo y Mantenimiento de los Vehículos Policiales - CA
    {
        id: 1116,
        tax: 0.21,
        sku: "iopos.course.online.curso-manejo-mantenimiento-vehiculos-policiales-2026-ca",
        title: "Curs de Maneig i Manteniment dels Vehicles Policials",
        name: "Curs de Maneig i Manteniment dels Vehicles Policials",
        short: "1.) Maneig i Manteniment dels Vehicles Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1114/image1"],
        banner: ["/1114/image1"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-mantenimiento-vehiculos-policiales-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1114,
        evolmind: { course_id: 1159, group_id: [3007] },
    },
    // 1117. Curso Modelos y Ejes Policiales
    {
        id: 1117,
        tax: 0.21,
        sku: "iopos.course.online.curso-modelos-ejes-policiales-2026",
        title: "Curs de Models i Eixos Policials",
        name: "Curs de Models i Eixos Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació especialitzada orientada a analitzar els models policials contemporanis i els eixos jurídics que fonamenten la seva actuació com a agència d’aplicació de la llei dins l’Estat de dret.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1117/image1"],
        banner: ["/1117/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelos-ejes-policiales/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1118, 1119],
        multiple_languages: false,
    },
    // 1118. Curso Modelos y Ejes Policiales - ES
    {
        id: 1118,
        tax: 0.21,
        sku: "iopos.course.online.curso-modelos-ejes-policiales-2026-es",
        title: "Curso Modelos y Ejes Policiales",
        name: "Curso Modelos y Ejes Policiales",
        short: "1.) Modelos y Ejes Policiales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1117/image1"],
        banner: ["/1117/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelos-ejes-policiales-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1118,
        evolmind: { course_id: 1168, group_id: [3016] },
    },
    // 1119. Curso Modelos y Ejes Policiales - CA
    {
        id: 1119,
        tax: 0.21,
        sku: "iopos.course.online.curso-modelos-ejes-policiales-2026-ca",
        title: "Curs de Models i Eixos Policials",
        name: "Curs de Models i Eixos Policials",
        short: "1.) Models i Eixos Policials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1117/image1"],
        banner: ["/1117/image1"],
        link: "/tienda/cursos/formacion-policial/curso-modelos-ejes-policiales-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1117,
        evolmind: { course_id: 1165, group_id: [3013] },
    },
    // 1120. Curso Calidad Policial
    {
        id: 1120,
        tax: 0.21,
        sku: "iopos.course.online.curso-calidad-policial-2026",
        title: "Curs de Qualitat Policial",
        name: "Curs de Qualitat Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació especialitzada orientada a implantar i consolidar sistemes de gestió de qualitat en l’àmbit policial, amb enfocament estratègic, orientació al ciutadà i cultura de millora contínua.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1120/image1"],
        banner: ["/1120/image1"],
        link: "/tienda/cursos/formacion-policial/curso-calidad-policial/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1121, 1122],
        multiple_languages: false,
    },
    // 1121. Curso Calidad Policial - ES
    {
        id: 1121,
        tax: 0.21,
        sku: "iopos.course.online.curso-calidad-policial-2026-es",
        title: "Curso Calidad Policial",
        name: "Curso Calidad Policial",
        short: "1.) Calidad Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1121/image1"],
        banner: ["/1121/image1"],
        link: "/tienda/cursos/formacion-policial/curso-calidad-policial-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1120,
        evolmind: { course_id: 1174, group_id: [3022] },
    },
    // 1122. Curso Calidad Policial - CA
    {
        id: 1122,
        tax: 0.21,
        sku: "iopos.course.online.curso-calidad-policial-2026-ca",
        title: "Curs de Qualitat Policial",
        name: "Curs de Qualitat Policial",
        short: "1.) Qualitat Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1122/image1"],
        banner: ["/1122/image1"],
        link: "/tienda/cursos/formacion-policial/curso-calidad-policial-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1120,
        evolmind: { course_id: 1171, group_id: [3019] },
    },
    // 1123. Curso de Seguridad Ciudadana Básica
    {
        id: 1123,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-basica-2026",
        title: "Curs de Seguretat Ciutadana Bàsica",
        name: "Curs de Seguretat Ciutadana Bàsica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "Formació operativa essencial orientada a capacitar els professionals policials en els procediments bàsics de seguretat ciutadana amb criteri tècnic, proporcionalitat i seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1123/image1"],
        banner: ["/1123/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-basica/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [1124, 1125],
        multiple_languages: false,
    },
    // 1124. Curso de Seguridad Ciudadana Básica - ES
    {
        id: 1124,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-basica-2026-es",
        title: "Curso de Seguridad Ciudadana Básica",
        name: "Curso de Seguridad Ciudadana Básica",
        short: "1.) Seguridad Ciudadana Básica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1123/image1"],
        banner: ["/1123/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-basica-2026-es/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1123,
        evolmind: { course_id: 1180, group_id: [3028] },
    },
    // 1125. Curso de Seguridad Ciudadana Básica - CA
    {
        id: 1125,
        tax: 0.21,
        sku: "iopos.course.online.curso-seguridad-ciudadana-basica-2026-ca",
        title: "Curs de Seguretat Ciutadana Bàsica",
        name: "Curs de Seguretat Ciutadana Bàsica",
        short: "1.) Seguretat Ciutadana Bàsica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.FORMACION_GENERAL_Y_ETICA_PROFESIONAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/1123/image1"],
        banner: ["/1123/image1"],
        link: "/tienda/cursos/formacion-policial/curso-seguridad-ciudadana-basica-2026-ca/",
        created_at: "2026-01-15 00:00:01",
        start_at: "2026-01-15 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        parent: 1123,
        evolmind: { course_id: 1177, group_id: [3025] },
    },
];
exports.default = products;
